/**
 * AttachmentChip Component
 * Displays a compact chip showing attachment file name and type icon in message bubbles
 */

import { File, Image, FileText } from 'lucide-react';
import type { AttachmentMeta } from '@/types/websocket.types';

const iconForType = (contentType?: string) => {
  if (!contentType) return File;
  if (contentType.startsWith('image/')) return Image;
  if (contentType === 'application/pdf' || contentType.includes('document') || contentType.includes('text'))
    return FileText;
  return File;
};

export const AttachmentChip = ({ attachment }: { attachment: AttachmentMeta }) => {
  const Icon = iconForType(attachment.content_type);

  return (
    <span className='inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-0.5 text-xs text-gray-600'>
      <Icon className='h-3 w-3 shrink-0' />
      <span className='truncate max-w-[140px]'>{attachment.name}</span>
    </span>
  );
};
